/* global google */
import React from 'react';
import PropTypes from 'prop-types';

import ReactDOM from 'react-dom';

import {withMap} from './utils';

import _ from 'underscore';


class Control extends React.Component {
  static displayName = 'Control';

  static propTypes = {
    position: PropTypes.number.isRequired,
    children: PropTypes.element.isRequired,
    map: PropTypes.object.isRequired,
    style: PropTypes.object,
    index: PropTypes.number,
  };

  componentDidMount() {
    this._el = document.createElement('div');
    _.each(this.props.style, (value, key) => {
      this._el.style[key] = value;
    });

    // This index affects control order among other controls in the same position
    // e.g. -1 will place a control at the bottom of other controls also at BOTTOM_RIGHT position
    if (this.props.index) {
      this._el.index = this.props.index;
    }
    this.props.map.controls[this.props.position].push(this._el);
    ReactDOM.render(this.props.children, this._el);
  }

  componentDidUpdate() {
    if (this._el) {
      ReactDOM.render(this.props.children, this._el);
    }
  }

  componentWillUnmount() {
    const controls = this.props.map.controls[this.props.position];
    const array = controls.getArray();
    const idx = array.findIndex((e) => (e === this._el));
    controls.removeAt(idx);
    ReactDOM.unmountComponentAtNode(this._el);
  }

  render() {
    return null;
  }
}

export default withMap(Control);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/Control.js